import { getTvObject, tv } from '@costar-ui/cosmos';

var chevronTvObject = getTvObject({
  base: 'size-5 text-inherit transition-transform duration-200 ease-in-out',
  variants: {
    isExpanded: {
      "true": '-rotate-90 transform'
    },
    isDisabled: {
      "true": 'text-neutral-subtle forced-colors:text-[GrayText]'
    }
  }
});
var treeItemTvObject = getTvObject({
  extend: ['outline-0', 'forced-colors:outline-[Highlight]'],
  base: ['group', 'relative', '-mb-px', 'flex', 'cursor-default', 'select-none', '-outline-offset-2', 'gap-3', 'overflow-hidden', 'px-3', 'h-8', 'first:border-t-0', 'last:mb-0', 'last:border-b-0'],
  variants: {
    border: {
      none: '',
      "default": ['border-b', 'border-y']
    },
    isFocusVisible: {
      "false": '',
      "true": 'border-focus outline-1'
    },
    isSelected: {
      "false": ['hover:bg-neutral-subtler', '[&:not([data-selection-mode="multiple"])]:data-[has-child-items]:hover:bg-action-primary', '[&:not([data-selection-mode="multiple"])]:data-[has-child-items]:hover:text-on-action-primary'],
      "true": ['z-20', 'data-[selection-mode="multiple"]:data-[has-child-items="true"]:hover:bg-neutral-subtler', '[&:not([data-selection-mode="multiple"])]:hover:bg-primary-subtler', '[&:not([data-selection-mode="multiple"])]:hover:text-on-primary-subtler', '[&:not([data-selection-mode="multiple"])]:bg-primary', '[&:not([data-selection-mode="multiple"])]:text-on-primary']
    },
    isDisabled: {
      "true": 'z-10 text-neutral-subtle forced-colors:text-[GrayText]'
    }
  }
});
var treeTvObject = getTvObject({
  base: 'relative w-full overflow-auto',
  variants: {
    border: {
      none: '',
      "default": ['border', 'border-b']
    },
    canShrink: {
      "true": ['min-h-0', 'shrink', 'grow']
    }
  }
});
var base = {
  tree: tv(treeTvObject),
  treeItem: tv(treeItemTvObject),
  chevron: tv(chevronTvObject)
};
var treeStyles = {
  base: base
};

export { treeStyles, treeTvObject };
//# sourceMappingURL=tree.styles.esm.js.map
